var _defs, _path, _path2, _polygon, _polygon2, _polygon3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCierrepasoVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 164.2 676.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #a00707;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.7,176.5L2,14.4C5.6,4.4,11.5,2.1,21.4,1.2c40.5-3.6,86.6,2.8,127.7.2,5.1-.6,15.5,9.2,15.5,12.9v162.1h.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.4,502.3c17.1,20.5,159.9,150.7,160.8,162,.7,8.9-10.4,12.6-17.5,13.2-40.1,3.9-86.9-3.1-127.8-.3-5,.7-15.5-9.1-15.5-12.8v-162.1h0Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1.4 211.9 8.5 215.5 164.6 371.7 164.6 458 1.4 295.9 1.4 211.9"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1.4 353.9 8.5 357.4 164.6 513.6 164.6 597.6 157.5 594 1.4 437.9 1.4 353.9"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1.4 70 164.6 232.1 164.6 316 1.4 154 1.4 70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCierrepasoVertical);
export default __webpack_public_path__ + "static/media/CIERRE PASO-VERTICAL.472c2f855c43572bcbd6e3ae3e1d1ad4.svg";
export { ForwardRef as ReactComponent };